/**
 * EffectsProcessor
 * ─────────────────────────────────────────────────────────────────────────────
 * Minimal processor — only stores the raw stream reference.
 * Background blur / virtual BG removed. All effects are CSS-based (zero lag).
 * Kept as a module so CommonContext wiring doesn't change.
 * ─────────────────────────────────────────────────────────────────────────────
 */

export const EFFECT_NONE = "none";

export class EffectsProcessor {
  constructor() {
    this._rawStream = null;
  }

  setRawStream(rawStream) {
    this._rawStream = rawStream;
  }
  async replaceRawStream(newStream) {
    this._rawStream = newStream;
  }
  getOutputStream() {
    return this._rawStream;
  }
  isActive() {
    return false;
  }
  async setEffect() {}
  deactivate() {}
  destroy() {
    this._rawStream = null;
  }
}

export const effectsProcessor = new EffectsProcessor();
